<div class="modal-header">
  <h6 class="modal-title">
    @if (modalTitle) {
      <b>{{modalTitle | messageTranslate}}</b>
    }
  </h6>
  <button type="button" class="btn-close" [attr.aria-label]="'Close' | messageTranslate" (click)="activeModal.close('User closed')"></button>
</div>
<div class="modal-body py-0">
  <div class="position-relative" [ngClass]="{'list-container-initial-loading': loading && !alertTicketsPage?.data?.length}">
    @if (alertTicketsPage?.count) {
      @for (ticket of alertTicketsPage.data; track ticket.ticket_id) {
        <a class="text-decoration-none text-dark clickable border-bottom row py-3"
           (click)="openTicketDetailsModal(ticket)">
          <div class="d-flex align-items-center col-6">
            {{ticket.summary}}
            @if (loadingTicketIds.has(ticket.ticket_id)) {
              <fa-icon class="ms-2" icon="spinner" animation="spin" />
            }
          </div>
          <div class="d-flex align-items-center justify-content-end column-gap-2 col text-body-secondary">
            <app-time-lapsed [timestamp]="ticket.updated_at" [abbreviated]="false" />
            <app-alert-ticket-status [ticket]="ticket" />
          </div>
        </a>
      }
    } @else {
      <div class="my-3">{{message | messageTranslate}}</div>
    }
    @if (loading) {
      <div class="position-absolute top-0 bottom-0 start-0 end-0 d-flex align-items-center justify-content-center bg-body bg-opacity-50">
        <app-ace-loading class="flex-grow-1" />
      </div>
    }
  </div>
  @if (moreTicketCount || viewAllAlertsLinkParams) {
    <div class="my-3">
      @if (moreTicketCount && paginationConfig) {
        <app-ace-pagination [count]="alertTicketsPage.count"
                            [page]="paginationConfig.page"
                            [pageSize]="paginationConfig.pageSize"
                            [showPageSizeSelect]="false"
                            (changePage)="setPage($event)"/>
      }
      <div class="d-flex mt-2 flex-md-row column-gap-2">
        @if (moreTicketCount && !paginationConfig) {
          <span>{{'+ X more' | messageTranslate: {items: moreTicketCount} }}</span>
        }
        @if (viewAllAlertsLinkParams) {
          <a [routerLink]="['/tickets', 'alerts', viewAllAlertsLinkParams.site_id]" target="_blank" rel="opener">{{'View all alerts' | messageTranslate}}</a>
        }
      </div>
    </div>
  }
</div>
